module.exports = __webpack_public_path__ + "static/fonts/Fact-MediumItalic.bc6edeb.woff";